"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _default2 = {
  name: 'ebook-card-render',
  props: {
    failed: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    loaded: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    ebook: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isbn: '',
      linkText: theme.strings.ebooks.loading,
      url: '#',
      libreDownloadRequireRetry: false,
      libreDownloadRetryFailed: false,
      successEbookDownload: false,
      failedDownload: false,
      downloadStatus: 'false',
      downloadResponse: {}
    };
  },
  methods: {
    getFirstAvailableVariant: function getFirstAvailableVariant(variants) {
      return variants.find(function (variant) {
        var variantTitle = variant.title ? variant.title : variant.variantTitle;
        return variantTitle.toLowerCase().includes('ebook');
      });
    },
    retryDownload: function retryDownload(event) {
      event.preventDefault();
      this.url = "#";
      this.linkText = theme.strings.ebooks.retry;
      this.$emit('retryDownload', this.ebook);
    },
    getLibreDownloadLink: function getLibreDownloadLink(isbn) {
      var _this = this;

      _axios["default"].get("https://libredigital.hcpservices.co.uk/api/ebook?isbn=".concat(isbn)).then(function (response) {
        if (response.data.status.toLowerCase() === 'success') {
          _this.downloadStatus = response.data;

          _this.updateDownloadLinkSuccess(response.data.ebookUrl);
        } else if (!_this.libreDownloadRequireRetry) {
          _this.retryLibreDownload();

          _this.linkText = theme.strings.ebooks.retry;
          _this.libreDownloadRequireRetry = true;
          _this.downloadStatus = 'retryLibreDownload';
        } else {
          _this.retryLibreDownload();

          _this.downloadStatus = 'updateDownloadLinkError';
        }

        return response;
      })["catch"](function (error) {
        _this.updateDownloadLinkError();

        window.console.error(error);
        return error;
      });
    },
    retryLibreDownload: function retryLibreDownload() {
      if (!this.loaded) {
        return;
      }

      if (Object.keys(this.data).length === 0) {
        this.$emit('retryProductDataDownload');
      }

      var variants = this.data.variants;

      if (!variants) {
        return;
      }

      var firstVariant = this.getFirstAvailableVariant(variants);

      if (firstVariant && firstVariant.hasOwnProperty('sku')) {
        this.isbn = firstVariant.sku.replace(/-/g, '');
        this.getLibreDownloadLink(this.isbn);
      }
    },
    updateDownloadLinkError: function updateDownloadLinkError() {
      this.failedDownload = true;
      this.linkText = theme.strings.ebooks.failed;
      this.$emit('failedDownload', this.ebook);
    },
    updateDownloadLinkSuccess: function updateDownloadLinkSuccess(ebookUrl) {
      this.url = ebookUrl.replace(/^http:\/\//, '//');
      this.linkText = theme.strings.ebooks.download;
      this.successEbookDownload = true;
      this.$emit('successDownload', this.ebook);
    },
    failedDownloadHandler: function failedDownloadHandler(event, isbn) {
      this.successEbookDownload = false;
      this.linkText = theme.strings.ebooks.loading;

      if (this.failed) {
        this.retryDownload(event);
        return event;
      }

      if (!this.successEbookDownload) {
        event.preventDefault();
        this.getLibreDownloadLink(isbn);
        return event;
      }
    }
  },
  mounted: function mounted() {
    this.getLibreDownloadLink(this.ebook.sku);
  },
  watch: {
    loaded: function loaded(isLoaded) {
      if (isLoaded && this.libreDownloadRequireRetry) {
        this.retryLibreDownload();
      }
    }
  }
};
exports["default"] = _default2;